import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Typography } from '@mui/material'
import { TextField } from '@carsys/form'

export const GeneralFormFields: React.FC<{}> = () => {
  const { t } = useTranslation()

  return (
    <Grid container direction='column' spacing={1.5}>
      <Grid item>
        <Typography variant='h5' gutterBottom>
          {t('Contact.AccountInformation')}
        </Typography>
      </Grid>
      <Grid item>
        <TextField label={t('setting_employee.email_address')} disabled name='EmailAddress' />
      </Grid>
      <Grid item>
        <Grid container direction='row' spacing={1}>
          <Grid item xs={6}>
            <TextField label={t('setting_employee.firstname')} disabled name='FirstName' />
          </Grid>
          <Grid item xs={6}>
            <TextField label={t('setting_employee.name')} disabled name='Name' />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <TextField label={t('shop.company.name')} disabled name='ShopName' />
      </Grid>
      <Grid item>
        <Grid container direction='row' spacing={1}>
          <Grid item xs={6}>
            <TextField label={t('workorder.wholesaler_orderaccount')} disabled name='WholesalerName' />
          </Grid>
          <Grid item xs={6}>
            <TextField label={t('Contact.YourShopID')} disabled name='ShopID' />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
